export const TRAINING_PLAN = 'training'
export const HIRING_PLAN = 'hiring'

// payment types for one time credit purchase
export const HIRING_PAYMENT = 'hiring-payment'
export const TRAINING_PAYMENT = 'training-payment'
